// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1VzB9","title":"Header_title__2rU_A","left":"Header_left__1_0tt","clinicName":"Header_clinicName__zb-T7"};